import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { List, ListItem, Paper, Typography } from '@mui/material';

import isEmpty from 'utils/is-empty';
import Utils from 'utils/Utils';

const useStyles = makeStyles()((theme) => ({
    head: {
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 30,
        marginTop: 60
    },
    paper: {
        background: '#FAFAFA',
        maxHeight: 300,
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        padding: '8px 20px'
    },
    listItem: {
        padding: '12px 0',
        borderBottom: '1px solid #EEEEEE',
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    listItemText: {
        color: theme.palette.primary.main,
        whiteSpace: 'pre',
        overflowX: 'hidden',
        textOverflow: 'ellipsis'
    }
}));

const References = ({ references }) => {
    const { classes } = useStyles();

    if (isEmpty(references)) {
        return null;
    }

    return (
        <div>
            <Typography className={classes.head} variant="h2">
                References
            </Typography>
            <Paper className={classes.paper} elevation={0}>
                <List className={classes.list}>
                    {references.sort(Utils.sortByNumberOrString).map((item, i) => (
                        <ListItem
                            className={classes.listItem}
                            button
                            component="a"
                            href={item}
                            target="_blank"
                            key={'references-' + i}
                        >
                            <Typography variant="body2" className={classes.listItemText}>
                                {item.replace('https://', '').replace('http://', '')}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Paper>
        </div>
    );
};

export default References;
